import Vue from 'vue';
import Vuex from 'vuex';
import RemaxService from '../../services/RemaxService';
import { ParcelDetail } from '../../models/ParcelDetail';
import SearchService from '@/services/SearchService';
import L from 'leaflet';

Vue.use(Vuex);

export interface ParcelState {
    selectedParcel: any | null; // this is an esri Feature type, no definition for it
    selectedParcelDetail: ParcelDetail | null;
}

export default {
    state: {
        selectedParcel: null,
        selectedParcelDetail: null,
    } as ParcelState,
    mutations: {
        SET_SELECTED_PARCEL(state: ParcelState, parcel: any) {
            state.selectedParcel = parcel;
        },
        SET_SELECTED_PARCEL_DETAIL(state: ParcelState, parcelDetail: ParcelDetail | null) {
            state.selectedParcelDetail = parcelDetail;
        },
    },
    actions: {
        setSelectedParcel(context: any, parcel: any) {
            context.commit('SET_SELECTED_PARCEL', parcel);
        },
        setSelectedParcelDetail(context: any, parcelDetail: ParcelDetail | null) {
            context.commit('SET_SELECTED_PARCEL_DETAIL', parcelDetail);
        },
        getParcelData(context: any, pid: string) {
            RemaxService.getParcelData(pid, context.rootState.isLoggedIn)
            .then((response: any) => {
                // console.log(response);
                if (response.error) {
                    console.error(response.error);
                    context.dispatch('parcelDataError');
                    context.dispatch('notify', response.error);
                } else {
                    const parcelDetail = new ParcelDetail(response.data);
                    context.commit('SET_SELECTED_PARCEL_DETAIL', parcelDetail);
                }
            })
            .catch((error) => {
                console.error(error);
                context.dispatch('parcelDataError');
                context.dispatch('notify', error);
            });
        },

        // EVENT_map_parcel_data_retrieved_error
        parcelDataError() {
            //
        },
        showParcelDialog() {
            //
        },
        goToParcel(context: any, pid: string) {
            SearchService.pidCentroidQuery(pid)
            .then((response) => {
                if (response && response.data && response.data.x && response.data.y) {
                    const latLon = new L.LatLng(response.data.y, response.data.x);
                    context.dispatch('goToLatLon', latLon);
                    context.dispatch('parcelClick', latLon);
                } else {
                    context.dispatch('notify', 'PID not found');
                }
            });

        },
    },
};
